module.exports = __webpack_public_path__ + "img/tob_8.9b9fceb6.svg";